import styled from '@emotion/styled';
import { Tag } from 'antd';

export const BlueTag = styled(Tag)`
  color: var(--fett-scenario-accent-text);
  border: solid 1px;
  border-color: #336fff;
  background: none;
  [data-color-mode='dark'] & {
    color: var(--fett-tag-blue-text);
    border-color: var(--fett-tag-blue-border);
  }
`;

export const GreenTag = styled(Tag)`
  border: solid 1px;
  color: #4aaf4e;
  border-color: #4aaf4e;
  background: none;
  [data-color-mode='dark'] & {
    color: var(--fett-tag-green-text);
    border-color: var(--fett-tag-green-border);
  }
`;

export const BlackTag = styled(Tag)`
  border: solid 1px;
  color: var(--fett-platform-tiktok-text);
  border-color: var(--fett-platform-tiktok-border);
  background: none;
`;

export const RedTag = styled(Tag)`
  border: solid 1px;
  color: var(--fett-surface-error-text);
  border-color: #f05b5b;
  background: none;
  [data-color-mode='dark'] & {
    color: var(--fett-tag-red-text);
    border-color: var(--fett-tag-red-border);
  }
`;
